import type { Config } from 'tailwindcss';

export default {
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  safelist: [
    {
      pattern: /(bg|fill)-chartColors-color[1-6]/,
    },
  ],
  theme: {
    extend: {
      colors: {
        primary: '#6B6BC7',
        textSecondary: '#8C8C8C',
        textDarkGrey: '#0D0D0D',
        textMedGrey: '#646464',
        borderMedGrey: '#F0F0F9',
        backgroundLightPurple: '#F8F8FC',
        backgroundPurple: '#F0F0F9',
        darkPurple: '#29296B',
        linkBlue: '#0092C7',
        chartColors: {
          color1: '#29296B',
          color2: '#4040A8',
          color3: '#6B6BC7',
          color4: '#8C8CD4',
          color5: '#BCBCE6',
          color6: '#DEDEF2',
        },
      },
      boxShadow: {
        card: '0px 1px 2px 0px rgba(13, 13, 13, 0.08)',
        filterCard: '0px 16px 12px -10px rgba(41, 41, 107, 0.06)',
        comboboxList: 'rgba(13, 13, 13, 0.16) 0px 4px 8px',
      },
      zIndex: {
        base: '0',
        sticky: '1',
        elevated: '10',
        dropdown: '20',
        header: '40',
        // teporary settings to fix conflicts with echo
        modal: '1002',
        tooltip: '1003',
        max: '1999',
      },
      gridTemplateColumns: {
        '15': 'repeat(15, minmax(0, 1fr))',
      },
    },
    fontFamily: {
      telegraf: ['Telegraf', 'sans-serif'],
    },
  },
  plugins: [],
} satisfies Config;
